<template>
  <div class="container">
    <b-overlay :show="isLoading">
      <vue-pdf-embed
        :source="loadPdf()"
        @rendered="isLoading = false"
      />
    </b-overlay>
  </div>
</template>

<script>
import { defineComponent, ref } from '@vue/composition-api'
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'

import cookiesFr from '@/assets/pdf/Charte-COOKIES_fr.pdf'

export default defineComponent({
  name: 'CookiesPolicy',

  components: {
    VuePdfEmbed,
  },
  setup(_props, ctx) {
    const { $store } = ctx.root

    const cookies = {
      fr: cookiesFr,
    }

    const isLoading = ref(true)

    const loadPdf = () => cookies[$store.state.appConfig.lang] || cookies.fr

    return {
      loadPdf,
      isLoading,
    }
  },
})
</script>
